import { render } from "./HeadSection.vue?vue&type=template&id=5bb89bd2&scoped=true"
const script = {}

import "./HeadSection.vue?vue&type=style&index=0&id=5bb89bd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5bb89bd2"

export default script